import { LegalLayout } from "./layout";

export default function Refund() {
  return (
    <LegalLayout title="Refund Policy" lastUpdated="March 23, 2026">
      <p>
        We want you to feel confident using Lerni. This policy explains how payments, cancellations, and refunds work.
      </p>

      <h2>1. Payments Are Non-Refundable</h2>
      <p>
        All subscription payments to Lerni are <strong>non-refundable</strong> by default. When you subscribe to a paid plan, you are charged for the current billing period in full, regardless of how much of the service you use during that period.
      </p>

      <h2>2. No Partial Refunds</h2>
      <p>
        We do not offer partial refunds for unused characters, unused days, or any portion of a billing period. This applies to all plans, including Pro and Premium.
      </p>

      <h2>3. Cancellation</h2>
      <p>
        You can cancel your subscription at any time. After cancellation, you will continue to have access to your current plan's features until the end of the paid billing period. Your account will then revert to the Free plan. You will not be charged again after cancellation.
      </p>

      <h2>4. Exception: Technical Issues</h2>
      <p>
        If you experience a significant technical issue on our end that prevents you from using the service — and we are unable to resolve it within a reasonable time — you may contact us at <strong>lernisupport@gmail.com</strong> to request a review. Refunds in these cases are evaluated on a case-by-case basis and are not guaranteed.
      </p>

      <h2>5. Duplicate Charges</h2>
      <p>
        If you believe you have been charged in error or duplicated, please contact us immediately at <strong>lernisupport@gmail.com</strong> and we will investigate and resolve it promptly.
      </p>

      <h2>6. How to Cancel</h2>
      <p>
        You can manage your subscription from the Settings page inside the Lerni app. Alternatively, contact us at <strong>lernisupport@gmail.com</strong> and we will assist you.
      </p>

      <h2>7. Contact</h2>
      <p>
        For any billing or refund questions, reach out to us at <strong>lernisupport@gmail.com</strong>.
      </p>
    </LegalLayout>
  );
}
